<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Categoria #' + this.$route.params.id : 'Nuova categoria')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                                    <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="categoria.descrizione" id="descrizione" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="tipo">Tipo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="categoria.tipo" :options="options">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="categoria.tipo == 'E'">
                                    <b-col sm="3"><label for="tipomenu">Tipo menù:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="categoria.tipomenu" :options="options_tipomenu">
                                            <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="categoria.tipo == 'E'">
                                    <b-col sm="3"><label for="bloccopartecipa">Blocco partecipa:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="categoria.bloccopartecipa" :options="options_bp" id="bloccopartecipa">

                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-show="categoria.tipo == 'E' || categoria.tipo == 'N'">
                                    <b-col sm="3"><label for="storico">Storico:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="categoria.storico" :options="options_bp" id="storico">

                                        </b-form-select>
                                    </b-col>
                                </b-row>


                                <b-row class="my-1">
                                    <b-col sm="3"><label for="ordinamento">Ordinamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="categoria.ordinamento" id="ordinamento" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="categoria.id != null">
                                    <b-col sm="3"><label for="allegato">Icona:</label></b-col>
                                    <b-col sm="9">
                                        <div v-if="categoria.allegato != ''">
                                            <b-img fluid width="50" height="50" :src="categoria.allegato" class="m-1" />
                                        </div>
                                        <div v-else>
                                            Nessuna
                                        </div>
                                        <!-- <b-form-input v-model="categoria.allegato" id="allegato" type="text"></b-form-input> -->
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="categoria.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                    <b-col sm="3" v-show="categoria.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="setIcona()">
                                            <div v-if="categoria.allegato != ''">
                                                Cambia icona
                                            </div>
                                            <div v-else>
                                                Aggiungi icona
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component Upload -->
    <b-modal v-model="uploadModal.show" title="Seleziona l'icona da caricare" @hidden="onHidden">
        <!-- <p class="my-2">Seleziona il file da inserire</p> -->
        <b-btn id="browse" ref="browse" size="md" variant="primary">Sfoglia...</b-btn>
        <h5>{{uploadModal.descrCaricamento}}</h5>
        <b-progress v-if="uploadModal.showPercent" :value="uploadModal.percentCaricamento" :max="100" show-progress animated></b-progress>
        <b-alert style="margin-top:10px;" :show="(uploadModal.errorCaricamento != '')" variant="danger">{{ uploadModal.errorCaricamento }}</b-alert>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="caricaIcona()" style="margin: 2px;">
                Carica
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="uploadModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE,
    TOKENUPLOAD
} from '../config.js'

import {
    Categoria
} from '../classes.js'

import {
    uuidv4
} from '../util.js'

import {
    ctrlVismenu
} from '../util.js'


import {
    Resumable
} from '../resumable.js'


export default {
    name: 'appdettaglio',
    data: function () {
        return {

            r: new Resumable({
                target: '',
                testChunks: true
            }),

            namespace: NAMESPACE,
            categoria: {
                id: this.$route.params.id || null,
                tipo: null,
                tipomenu: null,
                descrizione: '',
                bloccopartecipa: 'N',
                storico: 'N',
                ordinamento: 0,
                allegato: ''
            },
            options: [],
            options_tipomenu: [],
            options_bp: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            uploadModal: {
                show: false,
                descrCaricamento: '',
                showPercent: false,
                percentCaricamento: 0,
                errorCaricamento: '',
                uuidv4: ''
            },
            tipoAllegato: 'R'
        };
    },
    methods: {
        onHidden(evt) {
            this.r.cancel();
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        getTipiMenu() {

            var cat = new Categoria();
            var tipi = cat.getListaTipiMenu();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

            //return Object.assign({}, cat.getListaTipi());

        },
        getTipi() {

                var cat = new Categoria();
                var tipi = cat.getListaTipi();
                var keys = Object.keys(tipi);
                var options = [];
                for (var i = 0; i < keys.length; i++) {
                    options.push({
                        value: keys[i],
                        text: tipi[keys[i]]
                    });
                }

                return options;

                //return Object.assign({}, cat.getListaTipi());

            },
            setIcona() {

                this.uploadModal.showPercent = false;
                this.uploadModal.descrCaricamento = '';
                this.uploadModal.percentCaricamento = 0;
                this.uploadModal.errorCaricamento = '';
                this.uploadModal.show = true;
                this.uploadModal.uuidv4 = uuidv4();

                this.$nextTick(() => {
                    this.prepareUpload();
                });

            },
            caricaIcona() {

                if (this.r.files.length == 0) {
                    alert("Nessun file selezionato!");
                } else {
                    this.r.opts.target = NAMESPACE + 'rest/upload.php?id=' + this.uploadModal.uuidv4 + '&tokenupload=' + TOKENUPLOAD + '&caticona=true';
                    this.uploadModal.showPercent = true;
                    //console.log("Chiamo upload: " + this.r.opts.target)
                    this.r.upload();
                }

            },
            insert() {

                if (this.categoria.descrizione == "") {
                    this.showerror = true;
                    this.error = "Campo descrizione vuoto!";

                }
                else if (this.categoria.tipo == null) {
                    this.showerror = true;
                    this.error = "Tipo non selezionato!";

                }
                else if (this.categoria.tipomenu == null && this.categoria.tipo == 'E') {
                    this.showerror = true;
                    this.error = "Tipo menù non selezionato!";

                }
                else {

                    var json = JSON.stringify(this.categoria);

                    var appdettaglio = this;

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/categoria', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.categoria = res[0];

                                        this.showerror = false;
                                        this.showdettaglio = true; //anche se non dovrebbe servire
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$router.replace('/app/dettagliocategoria/' + this.categoria.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                this.showerror = true;
                                this.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            this.showerror = true;
                            this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }

            },
            prepareUpload(){

                //non rimuovere serve per resettare l'oggetto a ogni caricamento
                //altrimenti carica i file duplicandoli
                this.r = new Resumable({
                    target: '',
                    testChunks: true
                });

                this.r.assignBrowse(this.$refs.browse, false);

                        var rg = this.r;
                        var appdettaglio = this;

                        this.r.on('fileAdded', function(file, event) {
                            rg.files = rg.files.slice(-1); //prendo sempre solo l'ultimo file

                            //console.log("File added")

                            //ATTENZIONE: non cambiare è come se fosse una funzione esterna e quindi il this qui non funzionerebbe
                            appdettaglio.uploadModal.descrCaricamento = file.fileName;

                        });

                        this.r.on('fileSuccess', function(file, message) {
                            try {

                                //console.log("File success: " + message.trim())

                                var res = JSON.parse(message.trim());


                                if (!res.error) {
                                    appdettaglio.uploadModal.percentCaricamento = 100;

                                    var json = JSON.stringify({
                                        'id': null,
                                        'id_scheda': appdettaglio.categoria.id,
                                        'tipo': appdettaglio.tipoAllegato,
                                        's3': res.message.s3,
                                        'allegato': encodeURI(appdettaglio.uploadModal.uuidv4 + '/' + file.fileName)
                                    });

                                    var token = localStorage.getItem('token');
                                    appdettaglio.axios.post(NAMESPACE + 'rest/allegato', json, {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': token
                                            }
                                        })
                                        .then(response => {

                                            // JSON responses are automatically parsed.
                                            try {

                                                if (!response.data.error) {

                                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                                    appdettaglio.categoria.allegato = response.data.message[0].allegato;

                                                    setTimeout(function() {
                                                        //console.log("Modal false 1")
                                                        appdettaglio.uploadModal.show = false;
                                                    }, 1000);

                                                } else {
                                                    throw new Error(response.data.message);
                                                }


                                            } catch (e) {
                                                throw new Error(e.message);
                                            }

                                        })
                                        .catch(e => {
                                            throw new Error((e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                                        });




                                } else {
                                    throw new Error(res.message);
                                }

                            } catch (e) {
                                appdettaglio.uploadModal.errorCaricamento = "Errore: " + e.message;
                            }

                        });

                        this.r.on('progress', function() {
                            appdettaglio.uploadModal.percentCaricamento = rg.progress() * 100;

                            //console.log("Progress: " + rg.progress());

                            //FORZATURA NON BELLA
                            if (rg.progress() * 100 === 100 && appdettaglio.uploadModal.errorCaricamento == '') {
                                setTimeout(function() {
                                    //MOD S3
                                    if(appdettaglio.uploadModal.errorCaricamento == ''){
                                        appdettaglio.uploadModal.show = false;
                                    }
                                }, 1000);
                            }
                        });

                        this.r.on('error', function(message, file) {

                            appdettaglio.uploadModal.errorCaricamento = message;

                        });



            }


    },
    created: function () {

            if(!ctrlVismenu("T")){
                this.$router.replace('/accessdenied');
                return;
            }

            this.options = this.getTipi();

            this.options_tipomenu = this.getTipiMenu();

            var id = this.categoria.id; //se è la prima volta si prova a prendere da getid

            if (id != null) {

                var token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/categorie/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    appdettaglio.categoria = res[0];

                                    if(appdettaglio.categoria.tipo == 'E' && !appdettaglio.categoria.tipomenu){//evento
                                        appdettaglio.categoria.tipomenu = 'Z'; //sezioni
                                    }

                                    appdettaglio.showdettaglio = true;


                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

    },

}
</script>
